import React from 'react'

export const Show = ({ condition, children }) => (!condition ? null : children || null)
export const Hide = ({ condition, children }) => <Show condition={!condition}> {children} </Show>
